import React, { useState } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { includes } from 'lodash';
import { ButtonDiv, Button } from './styles/Button.styled';
import { IframeMap } from './styles/IFrameMap.styled';
import { ContactMap, LocationCaption, MapSection } from './styles/ContactLocationBlock.styled';
import MAP_STYLE from '../assets/data/map-style.json';

export default function GoogleMapBlock({ data, id, dir }) {
  const { title, location, zoom, markerIcon, link, markerLabel } = data;
  const locationArray = location.split(',');
  const lt = parseFloat(locationArray[0]);
  const ln = parseFloat(locationArray[1]);
  const zoomLevel = parseFloat(zoom);
  const isArabic = dir === 'rtl';
  const isContact = typeof window !== 'undefined' && includes(window.location.pathname, 'contact');

  const [infoDetails, setInfoDetails] = useState(isContact);

  const center = {
    lat: lt,
    lng: ln,
  };

  const containerStyle = {
    width: '100%',
    height: '100%',
  };

  return (
    <ContactMap id={id} dir={dir}>
      <LocationCaption>
        <h2>{title}</h2>
      </LocationCaption>
      <MapSection dir={dir} className="map_section">
        <IframeMap dir={dir}>
          <LoadScript
            language={isArabic ? 'ar' : 'en'}
            googleMapsApiKey={process.env.GATSBY_GOOGLE_API_KEY}
          >
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              options={{ styles: MAP_STYLE }}
              zoom={zoomLevel}
            >
              <Marker
                className="marker"
                icon={markerIcon?.url}
                position={center}
                onClick={() => {
                  setInfoDetails(true);
                }}
              />
              {infoDetails && (
                <InfoWindow
                  onCloseClick={() => {
                    setInfoDetails(null);
                  }}
                  position={center}
                >
                  <div
                    style={{ fontSize: 13, paddingBottom: 4, fontWeight: 500 }}
                    className="map-text"
                    dir={dir}
                  >
                    {markerLabel}
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
          </LoadScript>
        </IframeMap>
      </MapSection>
      {link ? (
        <ButtonDiv className="seccta">
          <Button
            href={link.url}
            stylevariant="secondarytransparent"
            rel=""
            className="google_map_btn"
            dir={dir}
            target={link.target}
          >
            {link.name}
          </Button>
        </ButtonDiv>
      ) : null}
    </ContactMap>
  );
}
